<app-location-component
  [zoom]="12"
  [address]="address"
  [latitude]="lat"
  [longitude]="lng"
  [label]="button?.button_label"
  [id]="id"
  [disabled]="button?.button_disable"
  [options]="options"
  (emitValues)="addLocationValues($event)"
></app-location-component>
